import exerciseTypesDefinitions from '../definitions';
import migrations from '../migrations';
export var getExerciseTypeVersionValidator = function getExerciseTypeVersionValidator(wantedType, wantedVersion) {
  return (// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    exerciseTypesDefinitions[wantedType][wantedVersion].validate
  );
};

var migrate = function migrate(type, wantedVersion, startVersion, data) {
  var typeMigrations = migrations[type];
  var version = startVersion;
  var updatedData = data;

  while (version !== wantedVersion) {
    // the last version has no migration, but it won't enter the loop
    var migration = typeMigrations[version];
    var validator = getExerciseTypeVersionValidator(type, version);

    if (migration) {
      if (validator(updatedData)) {
        var migrationResult = migration(updatedData);
        updatedData = migrationResult.data;
        version = migrationResult.version;
      } else {
        throw new TypeError("The data is not a valid '".concat(type, "' of version '").concat(version, "'."));
      }
    } else {
      break;
    }
  }

  return updatedData;
};

export var getExerciseTypeVersionAdapter = function getExerciseTypeVersionAdapter(wantedType, wantedVersion) {
  return function (type, version, data) {
    if (type !== wantedType) {
      throw new TypeError("Cannot convert from '".concat(type, "' to '").concat(wantedType, "'."));
    }

    var updatedData = migrate(wantedType, wantedVersion, version, data);
    var validator = getExerciseTypeVersionValidator(wantedType, wantedVersion);

    if (!validator(updatedData)) {
      throw new TypeError("Cannot convert '".concat(type, "' from '").concat(version, "' to '").concat(wantedVersion, "'."));
    }

    return updatedData;
  };
};